import { TableCell, Typography } from '@mui/material';

type ShareInvoicesTableHeaderCellProps = {
  text: React.ReactNode;
};

export const ShareInvoicesTableHeaderCell: React.FC<ShareInvoicesTableHeaderCellProps> = ({ text }) => {
  return (
    <TableCell
      sx={{
        paddingX: '0px',
      }}
    >
      <Typography
        fontWeight={500}
        fontSize="14px"
        lineHeight="24px"
        color={theme => theme.palette.text.primary}
      >
        {text}
      </Typography>
    </TableCell>
  );
};